export enum SignalCategories {
  Boundaries = 'BoundariesComponent',
  NoBoundaries = 'NoBoundariesComponent',
  PressurePoints = 'PressureComponent',
  LarsAndSworps = 'LarsSworpsComponent',
  LargeUsers = 'LargeUserComponent',
  SmartMeters = 'SmartMetersComponent',
}
